import * as React from "react";
import { useState, useContext, useEffect, useCallback } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import PortalUserContext from '~common/lib/portal-user-context';
import ErrorView from '~common/components/error-view';
import {
  Popper,
  Box,
  Chip,
  Autocomplete,
  Checkbox,
  CircularProgress,
  Input,
  Paper,
  ListItem,
  IconButton,
  InputAdornment,
  MenuItem
} from "@mui/material";
import {ValueContext} from '~common/components/form-def-field-fc';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import * as request from 'superagent';
import { getValueAtPath } from "~common/form/helper";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {ICGFormControl} from '~common/components/icg-form-control';
import { cloneDeep, isEqual } from "lodash";
import Renderers from '~common/lib/renderers';
import {StateContext}  from "~common/components/fields/address-field-fc";
import  {DataContext} from "~common/form/icg-definition-data-provider";
import classNames from 'classnames';
import {  debounce } from 'lodash';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
    },
    autoCompleteField: {
      width: "100%",
    },
    selectAllButton: {
      "&:hover": {
        backgroundColor: "#dcdbdc",
        // border: "solid #b8b8b8 1px",
      },
      // marginRight: -5,
      padding: 2,
      // border: "solid #ffffff 1px",
    },
    relationListChipFilter: {
      position: 'absolute', 
      right: -15, 
      cursor: 'pointer', 
      top: 25
    }
  })
);
function unwrapSuggestions(suggestions) {
  var unwrapped = [];
  if (suggestions) {
    suggestions.forEach((s: any) => {
      unwrapped.push(s);
    })
  }
    return unwrapped;

};
function unwrapValues(values) {
  var unwrapped = [];

  values.forEach((s: any) => {
    unwrapped.push(s.value);
  })

  return unwrapped;
};

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}


interface AutocompleteProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
  contextType?: string;
  // onAccessRootData?: Function;
  path:string;
}

export const AutocompleteField: React.FC<AutocompleteProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride,
  contextType,
  path,
  // onAccessRootData
}) => {

  const classes = useStyles(); 
  var dataContext
  if (DataContext !== null && DataContext !== undefined) {
    dataContext = useContext(DataContext)
  } else {
    console.warn("No DataContext Found. Conditional options will be unavailable.")
  }
  const [fullData] = dataContext || {}

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setBoolVal will pass the value up to the parent component that houses the context.
  
    // Initial Defitions, setting up the options, type, and state. 

  
    // This is used to highlight when using the filter button
    

  const filterConditionalOptions = () => {
    if (fieldDefinition && fieldDefinition.options && fieldDefinition.options.length > 0) {
      var options = fieldDefinition.options.filter((o: any) => {
        if (!o.conditions || o.conditions.length == 0) {
          return o;
        }
        if (o.conditions && o.conditions.length > 0) {
          var conditionResults = o.conditions.map((c: any) => {
            if (c.path == '_userType'){
                 if (PortalUserContext.userType == c.value) {
                  return true
                }
            } else if (c.path == '_hasOneOfFeatures'){
                var features = c.value.split("|");
                return PortalUserContext.hasOneOfFeatures(features);
          
            } else if (c.path.indexOf("~") != 0) {
              // Does not equal
              if (String(c.value).startsWith("!")) {
                var evalValue = String(c.value).substring(1)
                if (String(getValueAtPath(c.path, fullData || {})) != evalValue) {
                  return true
                }
                // Equals
              } else {

                // this conditional is using relative path. we need to construct a fullpath
                var condPathParts = c.path.split("/")
                // replace the key on the current field path with the key found in conditional relative path
                var fullConditionPath = path.replace(fieldDefinition.key, condPathParts[condPathParts.length-1])
          
                if (getValueAtPath(fullConditionPath, fullData || {}) == c.value) {
                  return true
                }
              }

            
            } else {
                if (getValueAtPath) {
                  var p = c.path
                    if (p.indexOf("~") == 0){
                      p = p.replace("~",'')
                    }
                  // Does not equal
                  if (String(c.value).startsWith("!")) {
                    var evalValue = String(c.value).substring(1)
                    if (String(getValueAtPath(p, fullData || {})) != evalValue) {
                      return true
                    }
                    // Equals
                  } else {
                    if(getValueAtPath(p, fullData || {}) == c.value) {
                      return true
                    }
                  }
    
                }
            }
            return false
          });

          // At this point the results from each conditional evaluation are in an array.  We need to evaluate the array based on the conditional operator.
          var conditionalOperator =  "or";
          if(o.conditionalOperator) {
            conditionalOperator = o.conditionalOperator
          }

          switch(conditionalOperator.toLowerCase()) {
            case "and":
              if (conditionResults.every(Boolean)) {
                return o;
              }
              break;
            default:
              if (conditionResults.some(Boolean)) {
                return o;
              }
              break;
          }

        }
      });
    }
    return options;
  }


  // intitial options are set to the field definition options, but then filtered based on conditional options
  // 
  var initialOptions = []

  if (fieldDefinition && fieldDefinition.options) {
    initialOptions = filterConditionalOptions()
  }

  const sectionContainerRef = React.createRef(null);

  // initValue is not a default value, rather it is a value to be set pre-component did mount. It is defined here so that it can be conditionally changed based on type, to fit in with what MUIAutocomplete expects, either a value or an array (for multiples)
  var initValue:any;

  const [errorMessage, setErrorMessage] = useState(null);
  const [probeValid, setProbeValid] = useState(false);
  
  const [chipFilterElement, setChipFilterElement] = useState(null);

  const highlight = (evt:any) => {
    var chips = sectionContainerRef.current.getElementsByClassName("MuiChip-label")
    for (var i = 0; i < chips.length; i++) {
      if (evt.target.value.length > 0 && chips[i].innerText.toLowerCase().indexOf(evt.target.value.toLowerCase()) > -1){
        chips[i].innerHTML = "<span class='highlighted' style='opacity:1'>" +chips[i].innerText + "</span>"
      } else if (evt.target.value.length == 0) {
        chips[i].innerHTML = "<span class='highlighted' style='opacity:1'>" +chips[i].innerText + "</span>"
      } else {
        chips[i].innerHTML = "<span class='blured' style='opacity: .3'>" +chips[i].innerText + "</span>"
      }
    
    }
  }

  var fieldType = "SimpleSelect"
  if (fieldDefinition.type && fieldDefinition.type == "Relation") {
    if (probeValid) {
      fieldType = "RelationStatic"
    } else {
      fieldType = "Relation"
    }
  } else if (fieldDefinition.type && fieldDefinition.type == "RelationList") {
    if (probeValid) {
      fieldType = "RelationListStatic"
    } else {
      fieldType = "RelationList"
    }

    initValue = []
  } else if (fieldDefinition.allowsMultiples) {
    fieldType = "MultiSelect"
    initValue = []
  }


  const [options, setOptions] = useState(initialOptions);
  const [inputVal, setInputVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  
  const [asUrl, setasUrl] = useState(fieldDefinition.autoSuggestURL);


  var parentContext = useContext(ValueContext);

  if (contextType && contextType != "") {
    switch (contextType) {
      case "state":
        parentContext = useContext(StateContext);
        break
    }
  } 

  const [fieldValue, setFieldValue] = parentContext;

  const [localValue, setLocalValue] = useState(initValue || "");


  const onListDelete = (label) => () => {
    if (localValue) {
      var newVals = localValue.filter((v) => v.label !== label)
      onChangeHandleToParent(newVals)
      setLocalValue((localValue) => localValue.filter((v) => v.label !== label));

    }
  };


  // Called when the inner TextField Component has a change, which in this case will trigger an API search. 
  const onInputChange =  async incomingValue => {
    if (fieldType == "MultiSelect" || fieldType == "SimpleSelect" || fieldType == "RelationStatic" || fieldType == "RelationListStatic") {
      setInputVal(incomingValue)
    }
    else {
      setLoading(true)
      setInputVal(incomingValue)
      debouncedSearch(incomingValue)
    }
  };

  // const probeOptions = async incomingValue => {
  const probeOptions = async incomingValue => {
    if (fieldDefinition.probeAutoSuggestURL) {
      var response = await fetchSuggestions(incomingValue, true)
      var unwraped = unwrapSuggestions(response)
      if (unwraped.length > 0) {
        setProbeValid(true)
      }
      if (unwraped.length == 1 && !fieldDefinition.suppressAutoSelection) {
        if (fieldType == "Relation" || fieldType == "RelationStatic") {
          // setFieldValue(unwraped[0])
          setFieldValue(unwraped[0])
        } else if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
          // setFieldValue({ relations: unwraped })
          setFieldValue({ relations: unwraped })
        }

      }

      setOptions(unwraped);

      // Need to now set the local value to the value of the field if it exists and is among the options
      // Limiting this to SimpleSelect for now
      if (fieldValue && fieldType == "SimpleSelect" && unwraped.some(item => item["value"] === fieldValue)) {
        setLocalValue(fieldValue)
      }

    }
  }

  // debounced search ensures that the query is not executed until the user stops typing for a specified delay.
  const debouncedSearch = useCallback( // this useCallback ensures that the debouncedSearch function is only re-created when the dependency (asUrl) changes
    debounce(async (query) => {
      const response = await fetchSuggestions(query, false);
      var unwraped = unwrapSuggestions(response)
      setLoading(false)
      setOptions(unwraped);
    }, 250), // debounce delay set to 250ms. We could get this from the field definition if we find that different delays are needed for different fields. 
    [asUrl] 
  )

  const fetchSuggestions = (query: string, probe: boolean) => {
    var queryValid = false
    setErrorMessage(null);
    var minQueryChars = fieldDefinition.minQueryChars
    if (asUrl && asUrl != "") {


      if (probe || (minQueryChars && query.length >= minQueryChars)) {
        queryValid = true
      } else if (!minQueryChars && query.length >= 2) {
        queryValid = true
      }
      if (queryValid) {

        let queryText: string = encodeURIComponent(query || "");
        const suggestRequest = { queryText: encodeURIComponent(query) };

        let attrname = "?query="
        if (fieldDefinition.autoSuggestURL.indexOf("?") > -1) {
          attrname = "&query="
        }

        var url = asUrl +
          attrname +
          (queryText || '') +
          appendToQuery();
          

        return new Promise(function (resolve, reject) {
          request
            .get(url)
            .then((response) => {
              if (response.statusCode == 200) {
                if (response.body) {
                  const limited = response.body.reduce((acc, item) => {
                    // REVIEW: EXCLUSIONS NOT CURRENTLY SUPPORTED
                    // if (!props.excluded || props.excluded.length == 0) {
                      acc.push(item);
                    // } else {
                    //   const ex = props.excluded.find((xItem) => {
                    //     return (
                    //       // Exsclude the item if
                    //       // If the excluded value matches the suggested value exactly
                    //       item.value == xItem.value ||
                    //       // If the excluded item key matches the suggested item (for string-back values like features
                    //       item.value == xItem.value.key ||
                    //       // If the suggestion has and ID and that value matches the excluded ID
                    //       (item.value.id && item.value.id === xItem.value.id)
                    //     );
                    //   });
                    //   // If not excluded, add it the the list.
                    //   if (!ex || ex.length == 0) {
                    //     acc.push(item);
                    //   }
                    // }
                    return acc;
                  }, []);
                  resolve(limited);
                } else {
                  resolve([])
                }
              } else {
                reject(response.body);
              }
            })
            .catch((err: any) => {
              // Rather than rejecting the promise, we resolve it with an empty array.  This will prevent the component from throwing uncaught errors.
              //reject(err);
              if (err && err.response && err.response.text) {
                setErrorMessage(err.response.text)
              }
              resolve([]);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          resolve([]);
        });
      }
    } else {
      return new Promise((resolve, reject) => {
        resolve(fieldDefinition.options);
      });

    }
  }

  const appendToQuery = () => {
    var append = '';
    if (fieldDefinition.appendToQuery && fieldDefinition.appendToQuery.length > 0) {
      fieldDefinition.appendToQuery.forEach((q: any) => {
        if (q.key && q.value) {
          append += `&${q.key}=${q.value}`;
        }
      });
    }
    return append;
  };


  const onAutoCompleteChange = (ev, val) => {
    if (ev.code != "Backspace"){
      // If the user clicks the 'X' to clear the field, do not propagate changes to parent to prevent chips from clearing
      if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
        if ((ev.currentTarget.classList || {value:''}).value.indexOf('MuiAutocomplete-clearIndicator') < 0 || chipsVariant) {
          setLocalValue(val)
          onChangeHandleToParent(val);
        } else {
          // This would typically hapen in onChangeHandleToParent
          
          setOptions([])
        }
      } else {
        // This test stops tabbing through a mutliselect from triggering a change on items that are already highlighted (which is the only case not protected by autohighlight)
        if (!(fieldType == "MultiSelect" && !fieldDefinition.freeSolo && ev.code == "Enter" && !ev.isTrusted)) {
          setLocalValue(val)
          onChangeHandleToParent(val);
        }
      }
    }
  }

  const onChangeHandleToParent = async val => {
    // setInputVal("")
    switch (fieldType) {
      case 'RelationStatic':

        if (fieldDefinition.relationType) {
          if (val) {
            val.type = fieldDefinition.relationType
          }
        }

        setFieldValue(val)
        break
      case 'Relation':
        
        if (fieldDefinition.relationType) {
          if (val) {
            
            val.type = fieldDefinition.relationType
          }
        }

        setOptions([])
        setFieldValue(val)
        break;
      case 'RelationListStatic':

        if (fieldDefinition.relationType) {
          if (val && val.length > 0) {
            val = val.map((v) => {
              v.type = fieldDefinition.relationType
              return v
            })
          }
        }

        setFieldValue({ relations: val })

        break;
      case 'RelationList':
        setOptions([])

        if (fieldDefinition.relationType) {
          if (val && val.length > 0) {
            val = val.map((v) => {
              v.type = fieldDefinition.relationType
              return v
            })
          }
        }

        setFieldValue({ relations: val })
        break;

      case 'MultiSelect':
        if (fieldDefinition.freeSolo && val && val[val.length-1] && !val[val.length-1].value) {
          var labelVal = cloneDeep(val[val.length-1])
          val[val.length-1] = {label: labelVal, value: labelVal}
        }
        
        var valArray = unwrapValues(val)
        setFieldValue(valArray.join('|'))
        break;

      default:

        if (val && val.value) {
          setFieldValue(val.value)
        } else if (!val) {
          setFieldValue(null)
        } else if (fieldDefinition.freeSolo) {
          setFieldValue(val)
        }
    }

  };


  const nullRender = () => {
    null
  }

  // initial options probe.
  // REVIEW check if this gets called ever milisecond
  useEffect(probeOptions, [])

  // if the autoSuggestURL changes, check to see if we should probe. 
  useEffect(()=>{
    if (asUrl != fieldDefinition.autoSuggestURL) {
        setasUrl(fieldDefinition.autoSuggestURL)
      }
  }, [fieldDefinition.autoSuggestURL])

  useEffect(()=>{
    if (fieldDefinition.probeAutoSuggestURL){
      probeOptions("")
    }
  }, [asUrl])

  // Hook to re-evaluate options when the data changes
  // Review: this may not be necessary with the hook below as well
  useEffect(() => {
    if (!probeValid) {
      var newOptions = filterConditionalOptions()
      if (!newOptions) {

        newOptions = []
      }
      setOptions(newOptions);
    }
  }, [fullData]);

  // This use effect reevaluated conditional options and changes the options if they come back different
  useEffect(() => {
    // Only applies to single select and multiselect, and will break relation fields if allowed to run rampant. 
    if (fieldType == "MultiSelect" || fieldType == "SimpleSelect") {
      var newOptions = filterConditionalOptions()
      if (!newOptions) {

        newOptions = []
      }
      // Checks if the new options are the same as the old options
      var isSame = (newOptions.length == options.length) && newOptions.every(function (element, index) {
        return element === options[index];
      });

      if (!isSame && !probeValid) {
      // if (!isSame ) {
        setOptions(newOptions);
      }
    }
  });

  // this hook handles setting localValue.label for SimpleSelect
  useEffect(() => {
    if (options && fieldType == "SimpleSelect" && localValue && localValue.value) {
      var lv = cloneDeep(localValue)
      var localValueLabel
      options.forEach((o:any)=>{
        if (o.value == lv.value) {
          localValueLabel = o.label
        }
      })  
      if (localValueLabel) {
        lv.label = localValueLabel
        setLocalValue(lv)
      }
    }  
}, [fieldValue, options])

// this hook handles setting localValue for probed MultiSelect that are not freeSolo
useEffect(() => {
  if (options && fieldValue && fieldType == "MultiSelect" && !fieldDefinition.freeSolo && probeValid) {
    var valueStrings = fieldValue ? fieldValue.split('|') : []
    var optionValues = Array<any>()
    for (var vString of valueStrings) {
      var foundOption = false
      for (var option of options) {
        if (option.value == vString) {
          foundOption = true
        }
      }
      if (foundOption) {
        optionValues.push({label: vString, value: vString})
      }
    }
    setLocalValue(optionValues)
}
}, [fieldValue, options])


  // Sets value if the incoming parent value (fieldValue) changes
  useEffect(() => {
      switch (fieldType) {
        case 'RelationStatic':
        case 'Relation':
          setLocalValue(fieldValue);
          break;

        case 'RelationListStatic':
        case 'RelationList':
          if (!fieldValue || fieldValue == "") {
            if (localValue.length != 0) {
              setLocalValue([]);
            }
          } else {
            if (fieldValue && fieldValue.relations) {
              setLocalValue(fieldValue.relations);
            }
          }


          break;

        case 'MultiSelect':

          if (!fieldValue || fieldValue == "") {
            if (localValue.length != 0) {
              setLocalValue([]);
            }
          } else {

            var valueStrings = fieldValue ? fieldValue.split('|') : []

            var optionValues = []
            for (var vString of valueStrings) {
              if (vString && vString != "") {
              var foundOption = false
                for (var option of options) {
                  if (option.value == vString) {
                    foundOption = true
                    optionValues.push(option)
                  }
                }

                if (!foundOption && fieldDefinition.freeSolo) {
                  optionValues.push({label: vString, value: vString})
                } 
              }

            }

            // REVIEW: may not be necessary with the [fieldValue] arg below
            if (optionValues.length != localValue.length) {
              setLocalValue(optionValues);
            }
          }
          break;

        // Standard Single Select
        default:
          var optionValue = null
          var foundOption = false
          for (var option of options) {
            if (option.value == fieldValue) {
              foundOption = true
              optionValue = option
            }
          }
        
          if (!foundOption && fieldValue && fieldValue != "" && fieldDefinition.freeSolo) {
            optionValue = {label: fieldValue, value: fieldValue}
          }

          // REVIEW: may not be necessary with the [fieldValue] arg below
          if (!isEqual(optionValue, localValue)) {
            setLocalValue(optionValue);
          }

      }
    }
  , [fieldValue]);


  var placeholder = ''
  if (fieldType == "Relation" || fieldType == "RelationList") {
    placeholder = "Start typing for suggestions"
  }

  if (fieldDefinition && fieldDefinition.placeholder && fieldDefinition.placeholder != "") {
    placeholder = fieldDefinition.placeholder
  }

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // FILTERING OUT ALREADY SELECTED ITEMS FOR RELATION LIST
  var filteredOptions = options
  if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
    for (var v of localValue) {
      filteredOptions = filteredOptions.filter((o) => o.label !== v.label)
    }
  }

  var minQueryChars = fieldDefinition.minQueryChars || 2

  var noOptionsText = ""


  // Reoriented this a little bit to provide better feedback to the user. JD 2020-09-22
  if (inputVal.length >= minQueryChars) {
    if (inputVal.length > 0) {
      if (!loading) {
        noOptionsText = "No options found"
      } else {
        noOptionsText = "Loading..."
      }
    }

  } else {
    if (fieldType == "Relation" || fieldType == "RelationList") {
      noOptionsText = "At least " + minQueryChars + " character(s) must be entered"
    }
  }


  var randID = makeid(10)
  var fullID = fieldDefinition.key + randID
  var chipsVariant = false
  if (fieldDefinition.variant && fieldDefinition.variant == "Chips") {
    chipsVariant = true
  }


  var probeDisplayMode = probeValid && options.length == 1 && !fieldDefinition.suppressAutoSelection && (fieldDefinition.mode == "Required" || fieldDefinition.mode == "Optional")
  // We have to use a custom popper to pass in the fit-content path to make the list items match the width of the label and not the field
  const CustomPopper = function (props) {
    return <Popper {...props} style={{ width: "fit-content", zIndex: 999999999 }} placement="bottom-start" />;
  };

  // If chipAttributes is set with a threshold, if the number of items in the list is greater, the user will be able to highlight matches
  var showFilterThreshold = 0
  if (fieldDefinition && fieldDefinition.chipAttributes && fieldDefinition.chipAttributes.showFilterThreshold) {
    showFilterThreshold = Number.parseInt(fieldDefinition.chipAttributes.showFilterThreshold || 0)
  }

  var renderTags;
  if ((fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant && nullRender) {
    // This is when we DON'T want to use the in-line chips
    renderTags = nullRender
  }


  var underFieldRenderer = null
  if ((fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant){
    underFieldRenderer = (
      <Box ref={sectionContainerRef}
        className={randID+"_Container"}
        mt={1}
        sx={{
          "& .MuiChip-root": { margin: 0.5 },
        }}
      >
        {localValue && (fieldType == "RelationList" || fieldType == "RelationListStatic") && localValue.map((v) => (
          <Chip key={v.label} label={v.label} title={v.label} disabled={fieldDefinition.mode == "Read Only" || readOnlyOverride || probeDisplayMode} onDelete={onListDelete(v.label)} />
        ))}
      </Box>
    )
  } 

  const renderOption = (props, option, { selected }) => {
      const suggestionRenderer: any = Renderers.find(fieldDefinition.suggestionRenderer)
      if (suggestionRenderer) {
        var S = suggestionRenderer
        return (
          <li {...props}>
            <S data={option} selected={selected} />
          </li>
        )
      }
      return (
        <ListItem {...props}>
          {fieldType == "MultiSelect" &&
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ margin: 0, marginRight: 8, padding: 0 }}
              checked={selected}
            />}
          {option.label}
        </ListItem>
      )
    }

  const onInputKeyDown = (evt) => {
    if (evt.code == "Tab" ) {
      // If we want the user to be able to tab through, we need to send an enter key event to the input field
      // before we allow the tab to happen. This will allow the user to tab through the options. selecting the first option
      // if there is no valid option, it will revert to the original value.
      evt.target.dispatchEvent(new KeyboardEvent('keydown', {code: 'Enter', key: 'Enter', keyCode: 13, bubbles: true}))
    }
  }
  const onInputChangeWrapper = (evt) => {
    if (evt.target.value !== "" || evt.target.value !== null) {
      
      onInputChange(evt.target.value);
    }
  }

  const onInputClick = (evt: any)=>{
    // allows the field info icon to be clicked, otherwise the input field will just be focused.
    if (evt.target.classList.contains('form-def-field-info')) {
      evt.stopPropagation()
    }
  }

  const onInputBlur = ()=>{
    // This will reset the noOptionsText originally reported in USF-1598
    if (fieldType == "Relation" || fieldType == "RelationList") {
      setInputVal("")
    }
    setInputFocused(false)

  }
  const onFocus = ()=>{
    // This will reset the noOptionsText originally reported in USF-1598
    setInputFocused(true)

  }
  

  const handleSelectAll = (evt: any)=>{
    // allows the field info icon to be clicked, otherwise the input field will just be focused.
    // if (evt.target.classList.contains('form-def-field-info')) {
    //   evt.stopPropagation()
    // }
    var newValue = ""
    for (var option of options) {
      newValue += option.value + "|"
    }
    setFieldValue(newValue)
  }

  

  const renderEndAdornment = (params) => {
    var extraAdornment = null
    
    if (params && params.InputProps && params.InputProps.endAdornment) {
      extraAdornment = params.InputProps.endAdornment
    }
    
    return (
      <React.Fragment>
        {loading ? (
          <CircularProgress color="inherit" size={20} />
        ) : null}
        {extraAdornment}
      </React.Fragment>
    )
  }

  const renderInput = (params) => {
    const inputProps = params.inputProps;
    const InputProps = params.InputProps;
    inputProps.autoComplete = navigator.userAgent.indexOf("Chrome") > -1 ? "new-password" : "off";
    inputProps["data-field-key"] = fieldDefinition.key;
    inputProps["data-field-path"] = path;
    inputProps["data-field-type"] = fieldDefinition.type;
    // inputProps.endAdornment = 
    var selectAllAdornment = null
    var allSelected = false
    if (fieldType == "MultiSelect" && fieldValue && fieldValue != "") {
      var valueStrings = fieldValue.split('|')
      allSelected = true
      for (var option of options) {
        if (valueStrings.indexOf(option.value) < 0) {
          allSelected = false
        }
      }
    }
    if ((fieldType == "MultiSelect" || fieldType == "RelationListStatic") && fieldDefinition.allowSelectAll && !allSelected && inputFocused ) {
      selectAllAdornment = (
        <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="select-all"
              fontSize="small"
              onClick={handleSelectAll}
              edge="end"
              className={classes.selectAllButton}
            >
              <DoneAllIcon/>
            </IconButton>
            {InputProps.endAdornment}
           </InputAdornment>
      )
    }

    if (selectAllAdornment) {
      InputProps.endAdornment = selectAllAdornment
    }

    return (
      <Input
        placeholder={placeholder || ""}
        className={classes.autoCompleteField}
        onKeyDown={onInputKeyDown}
        value={localValue}
        // onPaste={fieldDefinition.allowedCharacters ? onPaste : null}
        onChange={onInputChangeWrapper}
        onClick={onInputClick}
        onBlur={onInputBlur}
        onFocus={onFocus}
        sx={{ width: '100%' }}

        autoComplete={navigator.userAgent.indexOf("Chrome") > -1 ? "new-password" : "off"}
        endAdornment={renderEndAdornment(params)} 
        inputProps={inputProps}

        
        {...InputProps}
      />
    )
  }

  const isOptionEqualToValue = (option, value) => {
    if (option && value) {
     return option.value === value.value
    }
    return false
    
  }



  if (fieldDefinition.mode == "Display") {
    var displayValue: any
    switch (fieldType) {
      case 'RelationStatic':
      case 'Relation':
        if (localValue) {
          displayValue = localValue.label
        } else {
          displayValue =  ""
        }
        break
      case "SimpleSelect":
        var foundOption = false
        for (var option of options) {
          // Why does only field Value work here? shouldnt be a problem but why only this one?
          // I believe this allows us to only store the value in the database as opposed to having to store the value AND label - JP
          if (option.value == fieldValue) {
            foundOption = true
            displayValue = option.label
          }
        }
        if (!foundOption) {
          displayValue = "--"
        } 
        break
        
      case 'MultiSelect':
        var valueStrings = fieldValue ? fieldValue.split('|') : []

        var optionValues = []
        for (var vString of valueStrings) {
          if (vString && vString != "") {
            var foundOption = false
            for (var option of options) {
              if (option.value == vString) {
                foundOption = true
                optionValues.push(option)
              }
            }

            if (!foundOption) {
              optionValues.push({label: vString, value: vString})
            }
          } 
        }
          var chips = optionValues.map((v) => (
            <Chip key={v.label} label={v.label} title={v.label} disabled={false} />
          ))
          displayValue = <div>{chips}</div>

        break
      case 'RelationListStatic':
      case 'RelationList':
        if (localValue && localValue.length > 0) {
          var chips = localValue.map((v) => (
            <Chip key={v.label} label={v.label} title={v.label} disabled={false} />
          ))
          displayValue = <div>{chips}</div>
        } else {
          displayValue =  ""
        }
        break;
    }

    return (
    <ICGFormControl fieldDefinition={fieldDefinition} policyMessages={policyMessages} readOnlyOverride={readOnlyOverride}> 
        <div name={fieldDefinition.key} className={classes.displayText} data-field-value={typeof displayValue === 'string' ? displayValue : ''}>
          {displayValue}
        </div>
    </ICGFormControl>
    );
  }

  var forcePopupIcon = false
  if (fieldType == "SimpleSelect" || fieldType == "MultiSelect" || fieldType == "RelationStatic" || fieldType == "RelationListStatic"){
    forcePopupIcon = true
    if (fieldDefinition.freeSolo && filteredOptions == 0){
      forcePopupIcon = false
    }
  }

  var lv = localValue
  if (lv === null) {
    // The Autocomplete component does not like null values
    // Only undefined values are will actually clear the field
    lv = undefined
  }

  return (
    <ICGFormControl fieldDefinition={fieldDefinition} policyMessages={policyMessages} readOnlyOverride={readOnlyOverride || probeDisplayMode} suppressLabel={fieldDefinition.variant == "Question"} underFieldRenderer={underFieldRenderer}>
    <div>
      <Autocomplete
        // disablePortal
        id={fullID}
        name={fieldDefinition.key}
        // className={props.className}
        className={classes.autoCompleteField}
        PopperComponent={CustomPopper}
        autoHighlight={true}
        autoSelect={false}
        autoComplete={false}
        freeSolo={fieldDefinition.freeSolo}
        filterOptions={fieldDefinition.disableAutocompleteTextFilter ? (options) => options  : undefined}
        // autoHighlight={fieldType != "RelationList"}
        multiple={fieldType == "MultiSelect" || fieldType == "RelationList" || fieldType == "RelationListStatic"}
        disableCloseOnSelect={fieldType == "MultiSelect"}
        ChipProps={{ size: "small" }}
        // REVIEW: is this an "inline function"?
        isOptionEqualToValue={isOptionEqualToValue}
        disableListWrap
        // Declaring disabled here as well to disable the end adornment buttons
        disabled={fieldDefinition.mode == "Read Only" || readOnlyOverride || probeDisplayMode}
        noOptionsText={noOptionsText}
        // error={props.error}
        forcePopupIcon={forcePopupIcon}
        options={cloneDeep(filteredOptions)}
        value={lv}
        // required={fieldDefinition.mode == "Required"}
        renderOption={renderOption}
        // sx={{ width: 300 }}
        renderTags={renderTags}
        disableClearable={loading}
        // inputprops={{
        //   endAdornment: renderEndAdornment
        // }}
        onChange={onAutoCompleteChange}
        renderInput={renderInput}
      />

      {errorMessage != null && <ErrorView classes={{}} error={errorMessage} onClose={()=>{
        setErrorMessage(null)
      }} />}

      {showFilterThreshold > 0 && localValue.length > (showFilterThreshold - 1) && <i className={classNames("fa fa-filter", classes.relationListChipFilter)} style={{color: chipFilterElement != null ? 'green' : 'black'}} onClick={(evt:any)=>{
          evt.target._Target = randID
          if (chipFilterElement != null) { 
            var o = {
              target: {value: '', attributes: {
                  "data-target": {"nodeValue": randID}
                }
              }
            }
            highlight(o);
            setChipFilterElement(null);
          } else {
            setChipFilterElement(evt.target)
          }
        }} 
        />}

      <Popper style={{marginBottom: 5}} placement="top-end" anchorEl={chipFilterElement} open={chipFilterElement != null} >
        <Box style={{borderColor: '#b5b5b5', borderRadius: 7, marginBottom: 5}} sx={{ border: 1, p: 1, bgcolor: '#eff1f2' }}>
          <input data-target={randID} placeholder="Enter filter text" autoFocus={true} type="text" onKeyDown={(evt:any)=>{
            if (evt && evt.keyCode == 27) {
              var o:any = {
                target: {value: '', attributes: {
                  "data-target": {"nodeValue": randID}
                }
              }}
              highlight(o);
              setChipFilterElement(null);
            }
          }} onChange={highlight} style={{outline: 'none', border: 'none', borderBottom: '1px solid #b5b5b5',  height: 30, width: 250, marginTop: 2, borderRadius: 4, paddingLeft: 10}}  />
        </Box>
      </Popper>
      </div>
    </ICGFormControl> 
  );
};

export default AutocompleteField;